import { mutate } from "swr";

import * as fetcher from "../fetcher";
import { type CreateInstallationQuotationRequest } from "./types";

export const createInstallationQuotation = async (
  newInstallationQuotation: CreateInstallationQuotationRequest
) => {
  const res = await fetcher.opportunity.post<string, true>(
    "/installation-quotation/create",
    newInstallationQuotation,
    undefined,
    true
  );
  mutate(`/opportunities/${newInstallationQuotation.projectId}`);
  return res;
};
